import type { OnFetchErrorContext } from '@vueuse/core';

export const isErrorPolyfill = (err: unknown): err is Error => (Error.isError ? Error.isError(err) : err instanceof Error);

export const isAbortError = (error: OnFetchErrorContext['error']) => error?.name === 'AbortError';
